import React, { useState, useEffect, useRef } from 'react';
import { 
  Icon, 
  Menu,
  MenuItem, 
} from 'semantic-ui-react';

export default function HamburgerMenu(props) {
  const { setSelection } = props;
  const [open, setOpen] = useState(false);
  const [icon1Hovered, setIcon1Hovered] = useState(false);
  const [menuItemHovered, setMenuItemHovered] = useState(false);
  const [closeIconHovered, setCloseIconHovered] = useState(false);
  const menuWrapperRef = useRef(null);

  const iconStyle = {
    cursor: 'pointer',
    color: "#FFFFFF",
    padding: "0",
    margin: "0em 0em 0em 0em",
    position: "absolute",
    top: "50%",
    transform: "translate(-50%, -50%)",
  };

  const iconStyleHover = {
    ...iconStyle,
  };

  const closeIconStyle = {
    color: "#FFFFFF",
    position: 'absolute',
    top: '2em',
    right: '1em',
  };

  const closeIconHoverStyle = {
    ...closeIconStyle,
    cursor: 'pointer',
  };

  const menuItemStyle = {
    fontFamily: "'Lato', sans-serif",
    fontWeight: "400",
    backgroundColor: "transparent",
    color: "#F5F5F5",
  };

  const menuItemStyleHover = {
    ...menuItemStyle,
    cursor: 'pointer',
    fontWeight: "700",
  };

  const menuItems = [
    { key: 'home', text: 'Home', value: 'home' },
    { key: 'aboutUs', text: 'About Us', value: 'aboutUs' },
    { key: 'contactUs', text: 'Contact Us', value: 'contactUs' },
  ];

  const handleMenuItemClick = (_, { name }) => {
    setSelection(name);
    window.scrollTo(0, 0);
    setOpen(false);
    setMenuItemHovered(false);
    console.log(`${name.charAt(0).toUpperCase() + name.slice(1)} selected`);
  };

  const handleClickOutside = (event) => {
    if (menuWrapperRef.current && !menuWrapperRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  console.log(open);
  return (
    <div>
      {/* Hamburger Icon */}
      <Icon
        name="bars"
        size="big"
        aria-label="Open menu"
        role="button"
        tabIndex={0}
        onClick={() => setOpen(!open)}
        onMouseEnter={() => setIcon1Hovered(true)}
        onMouseLeave={() => setIcon1Hovered(false)}
        style={icon1Hovered ? iconStyleHover : iconStyle}
        onKeyPress={(e) => {
          if (e.key === 'Enter') setOpen(!open);
        }}
      />

      {/* Menu */}
      {open ? (
        <div 
          ref={menuWrapperRef} 
          style={{
            position: "fixed",
            zIndex: "99",
            height: "100vh",
            width: "40vw",
            top: "0",
            right: "0",
          }}
        >
          <Menu 
            vertical
            aria-label="Main menu"
            style={{
              height: "100vh",
              padding: "10em 0em 0em 0em",
              width: "40vw",
              backgroundColor: "#292929",
            }}
          >
            <Icon
              name="close"
              size="large"
              aria-label="Close menu"
              role="button"
              tabIndex={0}
              onClick={() => (setOpen(false), setCloseIconHovered(false))}
              onMouseEnter={() => setCloseIconHovered(true)}
              onMouseLeave={() => setCloseIconHovered(false)}
              style={closeIconHovered ? closeIconHoverStyle : closeIconStyle}
              onKeyPress={(e) => {
                if (e.key === 'Enter') setOpen(false);
              }}
            />

            {menuItems.map(item => (
              <MenuItem
                key={item.key} 
                name={item.value}
                active={item.text}
                onClick={handleMenuItemClick}
                onMouseEnter={() => setMenuItemHovered(item.key)}
                onMouseLeave={() => setMenuItemHovered(null)}
                style={menuItemHovered === item.key ? menuItemStyleHover : menuItemStyle}
              />
            ))}
          </Menu>
        </div>
      ) : (null)}
    </div>
  );
};